// Si el Estudio de Video se rompe al dibujar, se cae SÓLO el editor —
// ADR-2026-11-03-los-errores-del-estudio-se-ven.
//
// Había un único ErrorBoundary, en la raíz de la app: un clip con un dato roto que
// tiraba una excepción al dibujar se llevaba toda la app (sidebar incluida) y dejaba un
// texto rojo sin salida. Éste envuelve sólo el editor: avisa con la tarjeta de la casa,
// deja reintentar (vuelve a montar el editor, que relee el proyecto) o volver al
// listado, y registra el error en PostHog como el de la raíz.
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { captureException } from '../../lib/posthog';

type Props = { children: React.ReactNode };
type State = { error: boolean; intento: number };

export class ProteccionDelEditor extends React.Component<Props, State> {
  state: State = { error: false, intento: 0 };

  static getDerivedStateFromError(): Partial<State> {
    return { error: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    try {
      console.error('[ProteccionDelEditor]', error, info);
    } catch {}
    captureException(error, {
      origen: 'ProteccionDelEditor',
      componentStack: (info as { componentStack?: string })?.componentStack,
    });
  }

  render() {
    if (!this.state.error)
      // `key`: reintentar monta el editor de cero (relee el proyecto).
      return <React.Fragment key={this.state.intento}>{this.props.children}</React.Fragment>;
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-4">
        <div className="w-full max-w-[420px] rounded-lg bg-white p-6 text-center shadow-md ring-1 ring-black/[0.06] animate-modal-appear">
          <AlertCircle className="mx-auto mb-3 h-6 w-6 text-error" aria-hidden="true" />
          <h2 className="text-[17px] font-semibold text-brand-black">El editor tuvo un problema</h2>
          <p className="mt-2 text-[14px] text-brand-black/70">
            Algo de este proyecto no se pudo mostrar. Lo que ya estaba guardado sigue guardado.
          </p>
          <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={() => this.setState((s) => ({ error: false, intento: s.intento + 1 }))}
              className="rounded-md bg-brand-primary px-5 py-2.5 text-[14px] font-semibold text-white transition-[background-color,transform] duration-150 ease-out hover:bg-brand-primary-hover active:scale-[0.96]"
            >
              Reintentar
            </button>
            <button
              type="button"
              onClick={() => window.location.assign('/editor-video')}
              className="rounded-md px-5 py-2.5 text-[14px] font-semibold text-brand-black/70 ring-1 ring-black/[0.08] transition-[background-color,transform] duration-150 ease-out hover:bg-black/[0.04] active:scale-[0.96]"
            >
              Ver todos los proyectos
            </button>
          </div>
        </div>
      </div>
    );
  }
}
